// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Портфель проєктів» (Project portfolio, ключ `pfolio`, група `projects`). */
export const projectPortfolioManifest: IModuleManifest = {
  key: 'pfolio',
  group: 'projects',
  slug: 'project-portfolio',
  prefix: 'PFL',
  name: { en: 'Project portfolio', uk: 'Портфель проєктів' },
  entities: [
    { key: 'pfolio', slug: 'pfolio', name: { en: 'Project portfolio', uk: 'Портфель проєктів' }, main: true },
  ],
  loadState: () => import('./state/projectPortfolioSlice').then((m) => m.projectPortfolioSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
